import type { OrganizationProfile } from '@pulsify/shared'

export type NavKey =
  | 'overview'
  | 'listings'
  | 'place'
  | 'events'
  | 'earnings'
  | 'groups'
  | 'organizer'
  | 'menu'
  | 'actions'
  | 'aiStudio'
  | 'media'
  | 'crossposting'
  | 'settings'

interface NavItem {
  key: NavKey
  to: string
  params?: Record<string, string>
  search?: Record<string, string>
}

const OVERVIEW: NavItem = { key: 'overview', to: '/dashboard' }
const EVENTS: NavItem = { key: 'events', to: '/dashboard/events' }
const EARNINGS: NavItem = { key: 'earnings', to: '/dashboard/earnings' }
const GROUPS: NavItem = { key: 'groups', to: '/dashboard/groups' }
const ORGANIZER: NavItem = { key: 'organizer', to: '/dashboard/organizer' }
const AI_STUDIO: NavItem = { key: 'aiStudio', to: '/dashboard/ai-studio' }
const MEDIA: NavItem = { key: 'media', to: '/dashboard/media' }
const SETTINGS: NavItem = { key: 'settings', to: '/dashboard/settings' }

/** The sidebar for the active profile; null means profiles are off and the organization shows. */
export function navigationFor(
  profile: Pick<OrganizationProfile, 'kind' | 'listingId'> | null,
): NavItem[] {
  if (!profile) {
    return [
      OVERVIEW,
      { key: 'listings', to: '/dashboard/listings' },
      EVENTS,
      EARNINGS,
      ORGANIZER,
      { key: 'menu', to: '/dashboard/menu' },
      { key: 'actions', to: '/dashboard/actions' },
      AI_STUDIO,
      MEDIA,
      { key: 'crossposting', to: '/dashboard/crossposting' },
      SETTINGS,
    ]
  }
  if (profile.kind === 'place' && profile.listingId) {
    const listing = { listingId: profile.listingId }
    return [
      OVERVIEW,
      { key: 'place', to: '/dashboard/listings/$listingId', params: listing },
      EVENTS,
      EARNINGS,
      GROUPS,
      { key: 'menu', to: '/dashboard/menu', search: listing },
      { key: 'actions', to: '/dashboard/actions', search: listing },
      AI_STUDIO,
      MEDIA,
      { key: 'crossposting', to: '/dashboard/crossposting/$listingId', params: listing },
      SETTINGS,
    ]
  }
  return [OVERVIEW, ORGANIZER, EVENTS, EARNINGS, GROUPS, AI_STUDIO, MEDIA, SETTINGS]
}
